import { ErrorViewTemplate } from './error-view-template';

export const NotFoundView = () => {
  return (
    <ErrorViewTemplate
      title="Page non trouvée"
      message="La page que vous cherchez n'existe pas."
      code="404"
    />
  );
};
